import React, { createContext, useState } from "react";
import PMSIncomeServices from "../../services/pms_services/PMSIncomeServices";
import Notification from "../../components/common/Notification";

export const PMSIncomeContext = createContext("PMSIncomeContext");

const PMSIncomeContextProvider = ({ children }) => {

    const [loading, setLoading] = useState(false);
    const [leadingCreateIncome, setLoadingCreateIncome] = useState(false)
    const [errorMsg, setErrorMsg] = useState("");

    const [totalElements, setTotalElements] = useState(0);
    const [incomes, setIncomes] = useState(null);
    const [income, setIncome] = useState(null);
    const [incomeReport, setIncomeReport] = useState({
        totalCount: 0,
        totalIncome: 0
    });

    const [loadingDelete, setLoadingDelete] = useState(false);

    const generatePMSIncomeExcelReportByPharmacyId = async (pharmacyId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSIncomeServices.generatePMSIncomeExcelReportByPharmacyId(pharmacyId, params);
            if (res) {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", res.headers["content-disposition"].split("filename=")[1]);
                document.body.appendChild(link);
                link.click();
            }
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === "Network Error") {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };


    const getAllIncomesByPharmacyId = async (params) => {

        try {
            setLoading(true);
            setErrorMsg("");

            const res = await PMSIncomeServices.getAllIncomesByPharmacyId(params);

            setIncomeReport({
                totalCount: res.headers.count,
                totalIncome: res.headers.total
            });

            setIncomes(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);

            return true;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    }

    const getIncomeByPharmacyIdById = async (pharmacyId, id) => {
        try {
            setLoading(true);
            setErrorMsg("");

            const res = await PMSIncomeServices.getIncomeByPharmacyIdById(pharmacyId, id);
            setIncome(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    }

    const createIncomeByPharmacyId = async (id, data) => {

        try {
            setLoading(true);
            setLoadingCreateIncome(true);
            setErrorMsg("");

            await PMSIncomeServices.createIncomeByPharmacyId(id, data);

            Notification("success", "Added", "Income has been added successfully!");

            setLoading(false);
            setLoadingCreateIncome(false)
            return true;
        } catch (error) {
            setLoading(false);
            setLoadingCreateIncome(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    }

    const updateIncomeByIdByPharmacyId = async (id, pharmacyId, data) => {

        try {
            setLoading(true);
            setErrorMsg("");

            await PMSIncomeServices.updateIncomeByIdByPharmacyId(id, pharmacyId, data);
            Notification("success", "Updated", "Income updated successfully!");

            setLoading(false);
            return true;
        } catch (error) {

            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    }

    const deleteIncomeById = async (id, pharmacyId) => {
        try {
            setLoadingDelete(true);
            setErrorMsg("");

            await PMSIncomeServices.deleteIncomeById(id, pharmacyId);
            setIncomes(incomes.filter((income) => income?.id !== id));

            Notification("success", "DELETED", "Income has been deleted successfully");

            setLoadingDelete(false);
            return true;
        } catch (error) {
            setLoadingDelete(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    return (
        <PMSIncomeContext.Provider
            value={{
                loading,
                leadingCreateIncome,
                errorMsg,
                totalElements,
                incomes,
                income,
                incomeReport,
                getAllIncomesByPharmacyId,
                getIncomeByPharmacyIdById,
                createIncomeByPharmacyId,
                updateIncomeByIdByPharmacyId,
                generatePMSIncomeExcelReportByPharmacyId,
                deleteIncomeById,
                loadingDelete
            }}
        >
            {children}
        </PMSIncomeContext.Provider>
    )
}

export default PMSIncomeContextProvider;